import { FC } from 'react'
import { IconProps } from '@chakra-ui/react'

import { StarCircle } from 'components/icons'

type Props = IconProps

const ActivityType: FC<Props> = (props) => {
  return <StarCircle {...props} />
}

const ActivityTypeExports = {
  ActivityType,
}

export default ActivityTypeExports
